import { Component, Input, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule, NgIf } from '@angular/common';

@Component({
    selector: 'app-alert-content',
    templateUrl: './alert-content.component.html',
    styleUrls: ['./alert-content.component.scss'],
    imports: [CommonModule, NgIf]
})
export class AlertContentComponent {
  modal = inject(NgbActiveModal);


  @Input()
  header?: string;

  @Input()
  content?: string;

  @Input()
  contentType: 'text' | 'html' = 'text';

}
